module.exports = __webpack_public_path__ + "img/iocn_arrow.89c14ccc.svg";